<header class="section-header">
  <h2>روند سرعت روزانه</h2>
  <span>میانگین سرعت / <bdi>km/h</bdi></span>
</header>
<app-chart [context]="chartContext"></app-chart>
<p class="chart-note">این نمودار تفاوت رفتار سرعت در روزهای مختلف را نمایش می‌دهد.</p>
